import React from 'react';
import { CheckIcon } from '@heroicons/react/outline';

const featuresData = [
  {
    name: 'Email and SMS authentication',
    description:
      'Give users a beautiful. secure login experience using emails or phone numbers.'
  },
  {
    name: 'Social Logins',
    description:
      'Grant faster access with Google, Facebook, Github, Twitter and more.'
  },
  {
    name: 'Multi-sessions',
    description: 'Allow users to sign in to multiple accounts at once'
  },
  {
    name: 'Passwordless authentication',
    description:
      'Make passwords obsolete by sending Email Magic Links and One-time Password Codes (OTPs).'
  },
  {
    name: 'Multi Factor authentication',
    description: 'Encourage or require a second step during sign in.'
  },
  {
    name: 'Device management',
    description: 'Proactively notify users when a new device signs in.'
  }
];

type TProps = {
  className?: string;
};

export const Features: React.FC<TProps> = props => {
  const { className } = props;
  return (
    <section className={className}>
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:grid lg:grid-cols-3 lg:gap-x-8 lg:py-24 lg:px-8">
        <div>
          <h2 className="text-base font-semibold uppercase tracking-wide text-clerk-blue">
            Everything you need
          </h2>
          <h3 className="mt-2 text-3xl font-extrabold text-gray-900">
            The features your users expect
          </h3>
          <p className="text mt-4 text-gray-500">
            Signing up and signing in are the first interactions users will have
            with your product. Delight them with the familiar features they have
            come to expect.
          </p>
        </div>
        <div className="mt-12 lg:col-span-2 lg:mt-0">
          <dl className="space-y-10 sm:grid sm:grid-flow-col sm:grid-cols-2 sm:grid-rows-3 sm:gap-x-6 sm:gap-y-10 sm:space-y-0 lg:gap-x-8">
            {featuresData?.map(feature => (
              <div key={feature.name} className="relative">
                <dt>
                  <CheckIcon
                    className="absolute h-6 w-6 text-green-500"
                    aria-hidden="true"
                  />
                  <p className="text ml-9 font-medium leading-6 text-gray-900">
                    {feature.name}
                  </p>
                </dt>
                <dd className="mt-2 ml-9 text-base text-gray-500">
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};
